/**
 * @description Object type string for use with Type.typeName( obj )
 */
export enum TrueType {
	ARRAY = 'array',
	BOOLEAN = 'boolean',
	DATE = 'date',
	FUNCTION = 'function',
	NULL = 'null',
	NUMBER = 'number',
	OBJECT = 'object',
	REGEX = 'regexp',
	STRING = 'string',
	UNDEFINED = 'undefined'
}